import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '@/config/reactQuery';
import { QUERY_KEYS } from '../../queryKeys';
import { customers } from '../Customers';

export const useCustomers = () =>
  useQuery({
    queryKey: [QUERY_KEYS.customers],
    queryFn: async () => (await customers.getCustomers()).data,
  });

export const useCustomersHierarchy = () =>
  useQuery({
    queryKey: [QUERY_KEYS.customersHierarchy],
    queryFn: async () => (await customers.getCustomersHierarchy()).data,
  });

export const useCustomerInspectors = () =>
  useQuery({
    queryKey: [QUERY_KEYS.customerInspectors],
    queryFn: async () => (await customers.getCustomerInspectors()).data,
  });

export const useUserCustomers = (userId?: number) =>
  useQuery({
    queryKey: [QUERY_KEYS.users, userId],
    queryFn: async () => (await customers.getUserCustomers(userId)).data,
  });

export const useCreateCustomer = () =>
  useMutation({ mutationFn: customers.createCustomer });
export const useUpdateCustomer = () =>
  useMutation({ mutationFn: customers.updateCustomer });

export const useCreateInspector = () =>
  useMutation({
    mutationFn: customers.createInspector,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.customerInspectors],
      }),
  });
